import { Button } from "@/components/ui/button";
import { PartyPopper, ArrowRight, Grid3x3 } from "lucide-react";

export default function TryTopicComplete({ mode, topicLabel, isLastTopic = false, onContinue = () => {}, onPickAnother = () => {} }) {
  return (
    <div className="fade-up max-w-xl mx-auto text-center py-10" data-testid="try-topic-complete">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-emerald-100 mb-5 mx-auto">
        <PartyPopper className="w-8 h-8 text-emerald-600" />
      </div>
      <h3 className="font-display text-2xl font-bold text-slate-800 mb-2" data-testid="try-topic-complete-title">
        {isLastTopic ? "Guided demo complete!" : "Topic complete!"}
      </h3>
      <p className="text-slate-500 text-sm mb-7" data-testid="try-topic-complete-subtitle">
        {topicLabel}
      </p>

      {mode === "guided" ? (
        isLastTopic ? (
          <Button
            onClick={onContinue}
            className="rounded-full bg-sky-500 hover:bg-sky-600 text-white font-semibold px-8 py-6 tap-44"
            data-testid="try-restart-guided-btn"
          >
            Start over <ArrowRight className="w-4 h-4 ml-1.5" />
          </Button>
        ) : (
          <Button
            onClick={onContinue}
            className="rounded-full bg-sky-500 hover:bg-sky-600 text-white font-semibold px-8 py-6 tap-44"
            data-testid="try-next-topic-btn"
          >
            Continue to next topic <ArrowRight className="w-4 h-4 ml-1.5" />
          </Button>
        )
      ) : (
        <Button
          onClick={onPickAnother}
          className="rounded-full bg-sky-500 hover:bg-sky-600 text-white font-semibold px-8 py-6 tap-44"
          data-testid="try-pick-another-btn"
        >
          <Grid3x3 className="w-4 h-4 mr-1.5" /> Pick another topic
        </Button>
      )}
    </div>
  );
}
